module.exports = __webpack_public_path__ + "media/images/pages/home-2-05747cb433b9678ad0f551672cc0770a.jpg";